module.exports = __webpack_public_path__ + "img/site_picture.303d5599.png";